import { render, staticRenderFns } from "./ProjectBoard.vue?vue&type=template&id=7deb2dd4&scoped=true&"
import script from "./ProjectBoard.vue?vue&type=script&lang=js&"
export * from "./ProjectBoard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBoard.vue?vue&type=style&index=0&id=7deb2dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deb2dd4",
  null
  
)

component.options.__file = "ProjectBoard.vue"
export default component.exports